import fetchApi from "../fetchApi";
export const replaceCard = async ({
    office_id = '',
    old_processor_reference = '',
    new_processor_reference= '',
    skip_replace_fee = false,
    }) => {

    const payload = {
        office_id: office_id,
        old_processor_reference: old_processor_reference,
        new_processor_reference: new_processor_reference,
    };
    if (skip_replace_fee) {
        payload["skip_replace_fee"] = true;
    }

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(payload),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/replace`, options);
};
